// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".root[data-v-57a67d8d]{background-color:#fff}.root[data-v-57a67d8d] .v-application--wrap{min-height:auto;margin-top:-30px}.root[data-v-57a67d8d] .dc-btn--link{color:#26aafe}", ""]);
// Exports
module.exports = exports;
